// client/src/config.js
// Fallback URL updated 2026-05-03 (Sunday cleanup): old localgenie-api service
// has been suspended; this fallback now points to the active v2 service.
// In production, REACT_APP_API_BASE is set in Vercel, so this fallback only
// triggers in local dev without a .env file.
export const API_BASE1 =
  process.env.REACT_APP_API_BASE || "https://localgenie-api-v2.onrender.com";
